import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const ServerContext = createContext();

export function useServer() {
  return useContext(ServerContext);
}
export const api = axios.create({
  withCredentials: true
});

// Глобальный interceptor для ошибок
api.interceptors.response.use(
  response => {
    // console.log('API Response:', response.status, response.config.url, response.data);
    return response;
  },
  error => {
    // console.log('API Error:', error);
    // console.log('API Error Config:', error.config);
    // console.log('API Error Response:', error.response);
    
    if (error.response) {
      const msg = error.response.data?.error || error.response.statusText || 'Ошибка запроса';
      if (error.response.status === 404) return Promise.reject(error);
      if (error.code === 'ERR_CANCELED') return Promise.reject(error);
      toast.error(`Ошибка: ${msg} (${error.response.status})`);
    } else if (error.request) {
      toast.error('Нет ответа от сервера');
    } else {
      toast.error('Ошибка: ' + error.message);
    }
    return Promise.reject(error);
  }
);

export function ServerProvider({ children }) {
  const [servers, setServers] = useState([]);
  const [server, setServer] = useState(null);
  const [loading, setLoading] = useState(true);
  const serverRef = useRef(server);
  const serversRef = useRef(servers);
  serverRef.current = server;
  serversRef.current = servers;

  useEffect(() => {
    axios.get('/api/servers')
      .then(res => {
        const list = res.data.servers || [];
        setServers(list);
        // Восстанавливаем выбранный сервер из localStorage, если есть и он валиден
        const saved = localStorage.getItem('selectedServer');
        if (saved && list.some(s => s.id === saved)) {
          setServer(saved);
        } else if (list.length > 0) {
          setServer(list[0].id);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (server) localStorage.setItem('selectedServer', server);
  }, [server]);

  useEffect(() => {
    const interceptor = api.interceptors.request.use(config => {
      if (config.url && !config.url.startsWith('/api/servers')) {
        let currentServer = serverRef.current;
        if (!currentServer && serversRef.current.length > 0) {
          currentServer = serversRef.current[0].id;
        }

        const urlHasServer = typeof config.url === 'string' && /[?&]server=/.test(config.url);
        const paramsHasServer = config.params && config.params.server;
        if (currentServer && !urlHasServer && !paramsHasServer) {
          if (!config.params) config.params = {};
          config.params.server = currentServer;
        }
      }
      return config;
    });
    return () => api.interceptors.request.eject(interceptor);
  }, []);

  return (
    <ServerContext.Provider value={{ servers, server, setServer, loading }}>
      {children}
    </ServerContext.Provider>
  );
} 